{
  "app": {
    "title": "WStudio Reporting Admin",
    "shellTitle": "WSR Product Admin · Console Plateforme",
    "loading": "Chargement"
  },
  "common": {
    "save": "Enregistrer",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "remove": "Retirer",
    "create": "Créer",
    "edit": "Modifier",
    "close": "Fermer",
    "back": "Retour",
    "next": "Suivant",
    "retry": "Réessayer",
    "search": "Rechercher",
    "filter": "Filtrer",
    "clear": "Effacer",
    "reset": "Réinitialiser",
    "yes": "Oui",
    "no": "Non",
    "loading": "Chargement",
    "language": "Langue",
    "actions": "Actions",
    "menu": "Menu",
    "unmapped": "Non mappé",
    "comingSoon": "Bientôt disponible",
    "noProgress": "Aucune progression"
  },
  "help": {
    "ariaLabel": "Aide pour {{label}}",
    "scope": {
      "platform": "Plateforme",
      "platformDefault": "Par défaut",
      "tenantOverride": "Remplacement par locataire",
      "endpoint": "Endpoint",
      "allJobs": "Toutes les tâches",
      "genesisPacing": "Rythme de genèse",
      "outboundRate": "Débit sortant",
      "attendanceOnly": "Assiduité uniquement"
    }
  },
  "language_switcher": {
    "label": "Langue",
    "options": {
      "en": "English",
      "es": "Español",
      "fr": "Français",
      "pt": "Português"
    }
  },
  "nav": {
    "home": "Accueil",
    "tenants": "Locataires",
    "globalSettings": "Paramètres Globaux",
    "ingestionJobs": "Tâches d'Ingestion",
    "platformSection": "PLATEFORME",
    "signOut": "Se déconnecter",
    "signIn": "Se connecter",
    "group": {
      "operations": "Opérations",
      "configuration": "Configuration"
    },
    "dashboard": "Tableau de bord",
    "queue": "File d'attente",
    "notifications": "Notifications",
    "engine": "Moteur",
    "globalConfig": "Configuration globale"
  },
  "shell": {
    "globalStatus": "Global",
    "globalEnabled": "Activé",
    "globalDisabled": "Désactivé",
    "globalUnknown": "–",
    "globalStatusLabel": "État d'ingestion global",
    "scope": "Plateforme — tous les locataires",
    "notificationsAriaLabel": "Notifications",
    "role": {
      "productAdmin": "Administrateur produit"
    }
  },
  "page": {
    "dashboard": { "title": "Tableau de bord", "subtitle": "Santé de la flotte en un coup d'œil." },
    "queue": {
      "title": "File d'attente",
      "subtitle": "Profondeur de la file d'ingestion, activité et travaux à venir."
    },
    "notifications": { "title": "Notifications", "subtitle": "Alertes et notifications système." },
    "tenants": { "title": "Locataires", "subtitle": "Registre et configuration des locataires." },
    "engine": { "title": "Moteur", "subtitle": "Configuration du moteur et de la planification." },
    "globalConfig": {
      "title": "Configuration WStudio globale",
      "subtitle": "Chemins et paramètres des endpoints partagés par tous les locataires."
    }
  },
  "jobType": {
    "USER_SYNC": "Sync utilisateurs",
    "SALES_SYNC": "Sync ventes",
    "ATTENDANCE_SYNC": "Sync présences",
    "REPORT_USER_SYNC_SUMMARY": "Résumé sync utilisateurs",
    "GHL_FIELD_CHECK": "Vérification des champs GHL",
    "PRODUCT_SYNC": "Synchronisation des produits",
    "SALES_RECONCILE": "Réconciliation des ventes"
  },
  "jobTypeHelp": {
    "SALES_RECONCILE": "Reparcourt l'historique des ventes pour détecter les modifications ultérieures. Une exécution qui ne met rien à jour est une exécution saine."
  },
  "notifType": {
    "CREDENTIAL_INVALID": {
      "label": "Identifiants invalides",
      "title": "Identifiants invalides",
      "body": "L'identifiant {{integration}} pour {{jobType}} est invalide ou a expiré."
    },
    "INGESTION_JOB_FAILURE": {
      "label": "Échec de la tâche d'ingestion",
      "title": "Échec de la tâche d'ingestion",
      "body": "{{jobType}} a échoué. Dernière erreur : {{latestError}}"
    },
    "QUEUE_DEPTH_HIGH": {
      "label": "Profondeur de file élevée",
      "title": "Profondeur de file élevée",
      "body": "{{pending}} tâches sont en attente dans la file."
    },
    "USER_SYNC_NOT_CONFIGURED": {
      "label": "Sync utilisateurs non configurée",
      "title": "Sync utilisateurs non configurée",
      "body": "{{jobType}} n'est pas configuré : {{reason}}"
    },
    "USER_SYNC_EVENT_WRITE_FAILED": {
      "label": "Échec d'écriture de l'événement de sync utilisateurs",
      "title": "Échec d'écriture de l'événement de sync utilisateurs",
      "body": "Impossible d'écrire l'événement de sync utilisateurs : {{reason}}"
    },
    "SALES_SYNC_NOT_CONFIGURED": {
      "label": "Sync ventes non configurée",
      "title": "Sync ventes non configurée",
      "body": "{{jobType}} n'est pas configuré : {{reason}}"
    },
    "ATTENDANCE_SYNC_NOT_CONFIGURED": {
      "label": "Sync présences non configurée",
      "title": "Sync présences non configurée",
      "body": "{{jobType}} n'est pas configuré : {{reason}}"
    },
    "INGESTION_BREAKER_TRIPPED": {
      "label": "Sync désactivée — échecs répétés",
      "title": "Sync désactivée — échecs répétés",
      "body": "{{jobType}} a échoué sur {{failureDays}} jours distincts ({{failures}} exécutions échouées) dans les {{windowHours}} h — plus que les {{maxFailures}} tolérés — le service a donc été désactivé. Corrigez la cause, puis réactivez le service. Dernière erreur : {{latestError}}"
    }
  },
  "jobStatus": {
    "PENDING": "En attente",
    "CLAIMED": "Réclamé",
    "RUNNING": "En cours",
    "SUCCEEDED": "Réussi",
    "FAILED": "Échoué",
    "SKIPPED": "Ignoré"
  },
  "severity": {
    "INFO": "Info",
    "WARN": "Avertissement",
    "ERROR": "Erreur"
  },
  "lang": {
    "en": "EN",
    "es": "ES",
    "fr": "FR",
    "pt": "PT"
  },
  "auth": {
    "redirecting": "Redirection vers la connexion…",
    "returning": "Finalisation de la connexion…",
    "noAccessTitle": "Vous n'avez pas accès à cette console",
    "noAccessBody": "Votre compte est connecté, mais l'accès à cette console d'administration du produit ne lui a pas été accordé. Contactez votre administrateur si vous pensez qu'il s'agit d'une erreur.",
    "productAdminRequired": "Accès administrateur du produit requis",
    "productAdminRequiredBody": "Vous êtes connecté, mais l'accès à cette console d'administration du produit n'a pas été accordé à votre compte.",
    "signedOutTitle": "Vous êtes déconnecté",
    "signedOutBody": "Votre session d'administrateur de plateforme a pris fin.",
    "signInAgain": "Se connecter à nouveau",
    "errorTitle": "Connexion impossible",
    "errorBody": "Votre session n'a pas pu être restaurée. Essayez de vous reconnecter.",
    "tryAgain": "Réessayer"
  },
  "operator": {
    "menuTitle": "Compte",
    "platformAdminRequired": "Administrateur de plateforme requis",
    "platformAdminRequiredBody": "Vous n'avez pas la permission de voir ceci. Une accréditation ROLE_PLATFORM_ADMIN est requise.",
    "role": {
      "SAAS_ADMIN": "Admin Plateforme",
      "SUPER_ADMIN": "Super Admin"
    }
  },
  "tenants": {
    "title": "Locataires",
    "subline": "{{discovered}} découverts · {{active}} actifs · registre inter-locataires",
    "searchLabel": "Rechercher des locataires",
    "searchPlaceholder": "Rechercher locataire ou slug",
    "tableAriaLabel": "Registre des locataires",
    "col": {
      "tenant": "Locataire",
      "status": "Statut",
      "wstudio": "wStudio",
      "enabled": "Activé",
      "enables": "Activations",
      "services": "Services",
      "lastSync": "Dernière sync",
      "progress": "Progression"
    },
    "tabs": {
      "all": "Tous",
      "active": "Actifs",
      "paused": "En pause",
      "needsAttention": "Nécessite attention"
    },
    "enables": {
      "global": "Global",
      "tenant": "Locataire",
      "on": "Activé",
      "off": "Désactivé",
      "onNotRunning": "Activé, mais ne s'exécute pas"
    },
    "detail": {
      "wstudioNotConfigured": "Identifiants WStudio non configurés pour ce locataire.",
      "servicesTitle": "Services",
      "effectiveLabel": "Effectif : {{state}}"
    },
    "status": {
      "active": "Actif",
      "inactive": "Inactif",
      "suspended": "Suspendu"
    },
    "wstudio": {
      "configured": "Configuré",
      "notConfigured": "Non configuré"
    },
    "enabled": {
      "true": "Activé",
      "false": "Désactivé"
    },
    "lastSync": {
      "never": "—",
      "justNow": "À l'instant",
      "minutesAgo": "Il y a {{n}} min",
      "hoursAgo": "Il y a {{n}} h",
      "daysAgo": "Il y a {{n}} j"
    },
    "backfill": {
      "complete": "✓",
      "neverStarted": "—",
      "through": "jusqu'au {{date}}",
      "phase": {
        "BACKFILL": "Remplissage",
        "INCREMENTAL": "Incrémental"
      },
      "abbr": {
        "userSync": "US",
        "salesSync": "SS",
        "attendanceSync": "AT",
        "reportSummary": "RS"
      }
    },
    "service": {
      "userSync": "Sync utilisateurs",
      "salesSync": "Sync ventes",
      "attendanceSync": "Sync présences",
      "reportSummary": "Résumé rapport",
      "on": "Activé",
      "off": "Désactivé"
    },
    "emptyTitle": "Aucun locataire",
    "emptyBody": "Aucun locataire trouvé.",
    "emptySearch": "Aucun locataire ne correspond à votre recherche.",
    "emptyStatus": "Aucun locataire de cette page ne correspond aux filtres sélectionnés.",
    "loadError": "Impossible de charger les locataires.",
    "opsLoadError": "Impossible de charger les détails opérationnels.",
    "opsNotProvisioned": "Opérations non provisionnées",
    "statusFilter": {
      "label": "Statut",
      "all": "Tous",
      "active": "Actifs",
      "suspended": "Suspendus"
    },
    "actionFilter": {
      "label": "Nécessite une action",
      "pageOnly": "Filtre les locataires chargés sur cette page."
    },
    "pagination": {
      "previous": "Précédent",
      "next": "Suivant",
      "pageOf": "Page {{page}} sur {{total}}"
    },
    "createButton": "Créer un locataire",
    "create": {
      "title": "Créer un locataire",
      "slugLabel": "Slug",
      "slugHelper": "Lettres minuscules, chiffres, tirets — jusqu'à 63 caractères.",
      "slugRequired": "Le slug est obligatoire.",
      "slugInvalid": "Le slug doit être une étiquette DNS valide (minuscules, chiffres, tirets ; jusqu'à 63 caractères).",
      "nameLabel": "Nom",
      "nameRequired": "Le nom est obligatoire.",
      "nameTooLong": "Le nom doit comporter 200 caractères ou moins.",
      "signupModeLabel": "Mode d'inscription",
      "submitButton": "Créer",
      "submitting": "Création…",
      "cancelButton": "Annuler",
      "errorReservedSlug": "Ce slug est réservé. Choisissez-en un autre.",
      "errorDuplicateSlug": "Ce slug est déjà enregistré. Choisissez-en un autre.",
      "errorGeneric": "Impossible de créer le locataire. Veuillez réessayer.",
      "errorOutcomeUnknown": "Nous n'avons pas pu confirmer si le locataire a été créé. La liste des locataires a été actualisée : vérifiez-y la présence de « {{slug}} » avant de réessayer.",
      "longRunningHint": "La création d'un locataire peut prendre jusqu'à 30 secondes.",
      "success": "Locataire « {{name}} » créé."
    },
    "signupMode": {
      "PUBLIC": "Public",
      "INVITE_ONLY": "Sur invitation uniquement",
      "ADMIN_CREATED_ONLY": "Créé par admin uniquement",
      "DISABLED": "Désactivé"
    }
  },
  "queue": {
    "kpi": {
      "pending": "En attente",
      "inFlight": "En cours",
      "oldestPending": "Attente la plus ancienne",
      "failedLast24h": "Échecs (24h)"
    },
    "filters": {
      "tenantLabel": "Locataire",
      "allTenants": "Tous les locataires",
      "pollNote": "En direct — mise à jour toutes les ~5s",
      "searchLabel": "Filtrer les tâches",
      "searchPlaceholder": "Locataire, type, statut…"
    },
    "col": {
      "id": "ID",
      "tenant": "Locataire",
      "jobType": "Type de tâche",
      "kind": "Type",
      "status": "Statut",
      "timing": "Temps",
      "progress": "Progression"
    },
    "kind": {
      "GENESIS": "genèse",
      "BACKFILL": "historique",
      "LEADING_EDGE": "flux courant",
      "INCREMENTAL": "incrémental"
    },
    "rowsProcessed": "{{n}} lignes",
    "upcoming": {
      "title": "À venir",
      "overdueTitle": "En retard",
      "overdueBy": "{{duration}} de retard",
      "colTenant": "Locataire",
      "colJob": "Tâche",
      "colNext": "Prochain",
      "in": "dans {{duration}}",
      "dueNow": "dû maintenant",
      "empty": "Rien de planifié."
    },
    "card": {
      "running": "En cours depuis {{duration}}",
      "finishedAgo": "Terminé il y a {{duration}}",
      "scheduledFor": "Planifié {{time}}"
    },
    "tableAriaLabel": "Tâches en file",
    "empty": "Aucune tâche active.",
    "emptyFiltered": "Aucune tâche ne correspond aux filtres actuels.",
    "loadError": "Impossible de charger la file d'attente."
  },
  "notifications": {
    "filters": {
      "severityLabel": "Gravité",
      "allSeverities": "Toutes les gravités",
      "tenantLabel": "Locataire",
      "allTenants": "Tous les locataires",
      "platformOption": "Plateforme (*)",
      "tabsAriaLabel": "Filtrer par statut"
    },
    "tabs": {
      "all": "Toutes",
      "open": "Ouvertes",
      "acknowledged": "Reconnues",
      "resolved": "Résolues"
    },
    "status": {
      "OPEN": "Ouverte",
      "ACKNOWLEDGED": "Reconnue",
      "RESOLVED": "Résolue"
    },
    "meta": {
      "occurrences": "{{n}}× vue",
      "lastSeen": "Vue pour la dernière fois {{time}}"
    },
    "remedy": {
      "credentialInvalid": "Réauthentifiez l'identifiant {{integration}} dans saas-auth, puis réactivez {{jobType}}."
    },
    "actions": {
      "acknowledge": "Reconnaître",
      "openTenant": "Ouvrir le locataire"
    },
    "ackError": "Impossible de reconnaître cette notification. Réessayez.",
    "listAriaLabel": "Notifications",
    "empty": "Aucune notification.",
    "emptyFiltered": "Aucune notification ne correspond aux filtres actuels.",
    "loadError": "Impossible de charger les notifications.",
    "prevPage": "Page précédente",
    "nextPage": "Page suivante",
    "pageIndicator": "Page {{page}} sur {{total}}"
  },
  "dashboard": {
    "kpiRow": {
      "ariaLabel": "KPI de la flotte"
    },
    "kpi": {
      "enabledTenants": "Locataires activés",
      "enabledTenantsValue": "{{enabled}} sur {{total}}"
    },
    "depthTable": {
      "title": "Profondeur par type de tâche",
      "ariaLabel": "Profondeur de la file par type de tâche",
      "col": {
        "jobType": "Type de tâche",
        "pending": "En attente",
        "running": "En cours",
        "succeeded": "Réussi",
        "failed": "Échoué"
      },
      "empty": "Aucune donnée par type de tâche pour l'instant.",
      "loadError": "Impossible de charger la profondeur de la file."
    },
    "engineState": {
      "title": "État du moteur",
      "manageLink": "Gérer dans Moteur",
      "loadError": "Impossible de charger l'état du moteur."
    },
    "needsAttention": {
      "title": "Nécessite attention",
      "viewAll": "Voir toutes les notifications",
      "empty": "Aucune notification ouverte.",
      "loadError": "Impossible de charger les notifications."
    }
  },
  "globalConfig": {
    "formAriaLabel": "Formulaire de configuration WStudio globale",
    "loadError": "Impossible de charger la configuration WStudio globale.",
    "saveError": "Impossible d’enregistrer la configuration WStudio globale.",
    "saveSuccess": "Configuration WStudio globale enregistrée.",
    "save": "Enregistrer la configuration",
    "saveAll": "Enregistrer tous les paramètres",
    "saving": "Enregistrement…",
    "tabs": {
      "ariaLabel": "Sections de configuration globale WStudio",
      "enable": "Activer",
      "attendance": "Présence",
      "other": "Autres"
    },
    "notes": {
      "silentFailure": "Les valeurs des endpoints sont envoyées à WStudio telles qu’elles sont écrites. Une valeur incorrecte ne renvoie généralement aucune donnée plutôt qu’une erreur — vérifiez avec les tests à blanc après toute modification.",
      "invalidatesVerification": "L’enregistrement d’une modification incrémente la génération de configuration, ce qui rend obsolètes les résultats des tests à blanc de chaque locataire. Les locataires concernés cessent de lancer des traitements jusqu’à ce que leurs tests à blanc soient relancés."
    },
    "validation": {
      "path": "Saisissez un chemin commençant par /. Une requête fixe est autorisée."
    },
    "active": {
      "label": "WStudio activé",
      "help": "Détermine si la configuration WStudio partagée est active."
    },
    "groups": {
      "userList": {
        "title": "Liste des utilisateurs",
        "help": "Chemin de l’endpoint et paramètres de requête pour la liste des utilisateurs WStudio."
      },
      "sales": {
        "title": "Ventes",
        "help": "Chemins des endpoints et paramètres pour les ventes du locataire et par utilisateur."
      },
      "report": {
        "title": "Rapport",
        "help": "Chemin de l’endpoint du rapport de présence."
      },
      "other": {
        "title": "Paramètres supplémentaires",
        "help": "Clés globales supplémentaires renvoyées par wsr-api."
      }
    },
    "fields": {
      "unknownHelp": "Valeur globale fournie par wsr-api.",
      "WStudio_user_listWithFilters": {
        "label": "Chemin de la liste des utilisateurs",
        "help": "Chemin après le domaine du locataire. Une requête fixe est autorisée.",
        "detail": "Chemin vers la liste des utilisateurs WStudio, ajouté au domaine de chaque locataire. Fournit tous les membres connus de la plateforme. Il peut porter une chaîne de requête fixe ; `filter` et `filters` sont ajoutés par le moteur (voir ci-dessous)."
      },
      "WStudio_user_listWithFilters_max": {
        "label": "Maximum de la liste des utilisateurs",
        "help": "Nombre maximal d’utilisateurs demandés par page.",
        "detail": "Membres récupérés par requête. Le moteur pagine jusqu'à épuisement, cela règle donc la taille des requêtes, pas le nombre de membres synchronisés."
      },
      "WStudio_user_listWithFilters_offset": {
        "label": "Décalage de la liste des utilisateurs",
        "help": "Décalage initial des requêtes de liste d’utilisateurs.",
        "detail": "Position de départ de la première page. Laissez à zéro ; une autre valeur ignore définitivement des membres."
      },
      "WStudio_user_listWithFilters_filter": {
        "label": "Terme de recherche",
        "help": "Filtre facultatif envoyé avec les requêtes de liste d’utilisateurs.",
        "detail": "Terme de recherche libre de WStudio. Normalement vide, et il doit être envoyé même vide — l'endpoint ne renvoie rien si le paramètre est absent. Laissez-le vide sauf si vous voulez restreindre la liste aux noms correspondants."
      },
      "WStudio_user_listWithFilters_filters": {
        "label": "Critères de la liste",
        "detail": "Objet JSON de critères de WStudio — quels membres la liste inclut (actifs, bloqués, archivés, employés, administrateurs). Distinct de `filter` malgré le nom presque identique. Stocké en JSON brut ; le moteur gère l'encodage, ne collez donc pas une valeur déjà encodée pour URL."
      },
      "WStudio_sales_listSales": {
        "label": "Chemin des ventes du locataire",
        "help": "Chemin après le domaine pour les ventes de l’ensemble du locataire.",
        "detail": "Chemin vers le flux des ventes de tout le studio — la source de l'entrepôt des ventes et de tous les rapports de revenus. Sa chaîne de requête porte `includeDeleted` et un `filter=` vide obligatoire ; retirer l'un ou l'autre change ce qui revient, et omettre `filter=` ne renvoie rien."
      },
      "WStudio_sales_listForUser": {
        "label": "Chemin des ventes par utilisateur",
        "help": "Chemin après le domaine pour les ventes par utilisateur.",
        "detail": "Chemin vers l'historique des achats d'un membre. Sert à enrichir les données par membre, pas aux rapports de masse ; ce n'est pas la source de l'entrepôt des ventes."
      },
      "WStudio_sales_listForUser_max": {
        "label": "Maximum des ventes par utilisateur",
        "help": "Nombre maximal de ventes demandées par utilisateur.",
        "detail": "Taille de page et position de départ de l'historique d'un membre. Mêmes règles : l'offset doit rester à zéro."
      },
      "WStudio_sales_listForUser_offset": {
        "label": "Décalage des ventes par utilisateur",
        "help": "Décalage initial des requêtes de ventes par utilisateur.",
        "detail": "Taille de page et position de départ de l'historique d'un membre. Mêmes règles : l'offset doit rester à zéro."
      },
      "WStudio_sales_listForUser_forceUpdate": {
        "label": "Forcer la mise à jour",
        "help": "Valeur envoyée comme paramètre de mise à jour forcée des ventes par utilisateur.",
        "detail": "Activé, l'enrichissement par membre est rafraîchi à chaque synchronisation, et non seulement quand la date d'expiration a changé. Coûte une requête WStudio supplémentaire par membre et par exécution ; laissez désactivé sauf si les données paraissent obsolètes."
      },
      "WStudio_report_checkin": {
        "label": "Chemin du rapport de présence",
        "help": "Chemin après le domaine pour le rapport de présence.",
        "detail": "Chemin vers le générateur du rapport d'assiduité. Renvoie un lien vers un classeur généré, que le moteur télécharge puis analyse — un appel en deux étapes, donc un changement ici affecte les deux."
      },
      "WStudio_product_listByType": {
        "detail": "Chemin vers le catalogue produits, interrogé une fois par type de produit (ci-dessous). Le catalogue est ce qui permet de classer une vente comme abonnement, forfait de cours ou coaching personnel."
      },
      "WStudio_product_listByType_max": {
        "detail": "Taille de page et position de départ du catalogue produits. Les catalogues sont petits ; les valeurs par défaut méritent rarement d'être changées."
      },
      "WStudio_product_listByType_offset": {
        "detail": "Taille de page et position de départ du catalogue produits. Les catalogues sont petits ; les valeurs par défaut méritent rarement d'être changées."
      },
      "WStudio_product_types": {
        "detail": "Liste de types de produits à récupérer, séparés par des virgules, p. ex. `byTime`. Le catalogue est interrogé une fois par type : ajouter un type ajoute une requête par locataire et par exécution. Les types absents ne sont jamais récupérés, et une vente qui les référence ne pourra pas être classée."
      },
      "WStudio_membership_gracePeriodDays": {
        "detail": "Combien de temps après l'expiration d'un abonnement un membre reste considéré actif, en période de grâce, avant d'être traité comme échu. Réglez-le sur la durée pendant laquelle vous appelleriez encore quelqu'un membre après un paiement manqué."
      },
      "WStudio_membership_shortTermThresholdDays": {
        "detail": "Durée en dessous de laquelle un achat compte comme court terme plutôt qu'abonnement. Un pass hebdomadaire passe en dessous ; un abonnement mensuel non. Cela décide si un acheteur est étiqueté membre ou visiteur occasionnel."
      },
      "WStudio_membership_renewalDueSoonDays": {
        "detail": "Combien de jours avant l'expiration un membre est signalé comme à renouveler, pour que le marketing agisse avant l'échéance plutôt qu'après."
      },
      "WStudio_membership_tenureEstablishedDays": {
        "detail": "Durée depuis le premier achat au-delà de laquelle un membre n'est plus « nouveau ». En dessous il est nouveau ; au-dessus, établi."
      },
      "WStudio_membership_tenureLoyalDays": {
        "detail": "Durée depuis le premier achat au-delà de laquelle un membre compte comme fidèle. Doit être supérieure au seuil « établi »."
      },
      "WStudio_membership_productFamilyByCategory": {
        "detail": "Associe vos catégories de produits WStudio aux trois familles comprises par la plateforme — abonnement, cours et coaching personnel — sous forme de paires `catégorie:famille` séparées par des virgules. Une entrée mal formée est ignorée silencieusement : une faute de frappe fait que la catégorie n'est jamais associée ; vérifiez le résultat après modification plutôt que de le supposer."
      },
      "WStudio_membership_valueMidThreshold": {
        "detail": "Seuils de dépense cumulée séparant les membres de valeur faible, moyenne et élevée. Les montants sont dans la devise des ventes du membre lui-même, sans conversion — un membre dont les achats couvrent deux devises est laissé sans tranche plutôt que doté d'un total trompeur. Les deux doivent être définis, sinon aucune tranche n'est produite."
      },
      "WStudio_membership_valueHighThreshold": {
        "detail": "Seuils de dépense cumulée séparant les membres de valeur faible, moyenne et élevée. Les montants sont dans la devise des ventes du membre lui-même, sans conversion — un membre dont les achats couvrent deux devises est laissé sans tranche plutôt que doté d'un total trompeur. Les deux doivent être définis, sinon aucune tranche n'est produite."
      },
      "WStudio_genesis_syncReadyCoverageDays": {
        "detail": "Quelle profondeur d'historique d'assiduité doit être chargée avant qu'un locataire commence à se synchroniser avec GoHighLevel. C'est la condition qui décide quand un locataire nouvellement activé passe en production ; tant qu'elle n'est pas atteinte, rien n'arrive au CRM — ce qui est correct, car des signaux d'engagement calculés sur un historique partiel seraient faux. Abaissez-la pour démarrer plus tôt avec moins d'historique ; augmentez-la pour être plus prudent."
      },
      "GhlFieldMappings_CONTACT_PREFIX": {
        "detail": "Préfixe identifiant les réglages qui associent les champs de membre WStudio aux champs de contact GoHighLevel. Structurel plutôt qu'un réglage : le changer rend orphelines toutes les correspondances existantes."
      }
    }
  },
  "global": {
    "title": "Paramètres Globaux",
    "subtitle": "Contrôles à l'échelle de la plateforme. Les modifications s'appliquent à chaque locataire.",
    "enableSection": "Ingestion globale",
    "enableDescription": "Quand désactivé, le planificateur ne met rien en file d'attente pour aucun locataire. La découverte continue de s'exécuter pendant ce temps.",
    "enableLabel": "Activer l'ingestion globale",
    "toggleEnabled": "Activé",
    "toggleDisabled": "Désactivé",
    "toggleUnknown": "Inconnu",
    "toggleSuccessOn": "Ingestion globale activée.",
    "toggleSuccessOff": "Ingestion globale désactivée.",
    "toggleError": "Impossible de mettre à jour le paramètre global. Veuillez réessayer.",
    "discoverySection": "Découverte du registre",
    "discoveryDescription": "Exécute le balayage de réconciliation saas-auth à la demande. Les nouveaux locataires se matérialisent en mode dormant et désactivés.",
    "discoveryButton": "Lancer la découverte maintenant",
    "discoveryRunning": "Découverte en cours…",
    "discoveryError": "La découverte a échoué. Veuillez réessayer.",
    "discoveryResultTitle": "Découverte terminée",
    "discoveryResultSeen": "Vus",
    "discoveryResultCreated": "Créés",
    "discoveryResultStatusUpdated": "Statut mis à jour",
    "discoveryResultLeaversFlagged": "Partants signalés",
    "statsSection": "Comptages de flotte",
    "statTotal": "Total des locataires",
    "statActive": "Actifs",
    "statActiveNote": "(statut = actif)",
    "statWstudio": "wStudio configuré",
    "loadError": "Impossible de charger les comptages de flotte."
  },
  "engine": {
    "loadError": "Impossible de charger la configuration du moteur.",
    "formAriaLabel": "Formulaire de configuration du moteur",
    "restartRequired": "Redémarrage requis",
    "unit": {
      "seconds": "secondes",
      "count": "nombre"
    },
    "validation": {
      "secondsMin1": "Doit être un entier ≥ 1.",
      "countMin0": "Doit être un entier ≥ 0.",
      "countMin1": "Doit être un entier ≥ 1.",
      "isolationInvalid": "Doit être l'un des 5 niveaux d'isolation pris en charge.",
      "invariant": "heartbeatIntervalSeconds doit être inférieur à leaseTtlSeconds, qui doit être inférieur à maxExecutionTimeSeconds.",
      "invariantHint": "Fait partie de l'invariant heartbeat/lease/max-execution."
    },
    "save": {
      "success": "Configuration enregistrée.",
      "error": "Impossible d'enregistrer la configuration. Veuillez réessayer.",
      "changedCount": "{{count}} modifiés",
      "noChanges": "Aucun changement",
      "revert": "Rétablir",
      "save": "Enregistrer",
      "saveAll": "Enregistrer tous les paramètres",
      "saving": "Enregistrement…"
    },
    "tabs": {
      "ariaLabel": "Sections des paramètres du moteur"
    },
    "group": {
      "cadence": "Cadences",
      "retention": "Rétention",
      "tuning": "Réglages"
    },
    "flags": {
      "title": "Démarrer / arrêter",
      "globalReadOnly": "Global (lecture seule — voir Locataires)",
      "toggleError": "Impossible de mettre à jour. Veuillez réessayer.",
      "engineEnabled": "Moteur",
      "engineEnabledDescription": "La boucle dispatcher/claimer/heartbeat/reaper qui exécute les tâches.",
      "discoveryEnabled": "Découverte",
      "discoveryEnabledDescription": "Le balayage de réconciliation du registre des locataires saas-auth.",
      "pruneEnabled": "Élagage",
      "pruneEnabledDescription": "Nettoyage de rétention des tâches terminales et des événements.",
      "orphanSweepEnabled": "Balayage des orphelins",
      "orphanSweepEnabledDescription": "Supprime les fichiers temporaires résiduels du traitement d'assiduité, qui télécharge un classeur généré sur disque et l'efface normalement aussitôt. Ce balayage est le filet de sécurité si le processus est tué pendant le téléchargement. Il ne touche ni aux tâches ni aux données."
    },
    "fields": {
      "engineEnabled": {
        "detail": "Interrupteur principal de la boucle d'ingestion : répartiteur, préleveur, battement et récupérateur. L'éteindre est une pause maîtrisée — les tâches en cours se terminent, rien de nouveau n'est mis en file ni prélevé, aucune donnée n'est perdue. À utiliser pour mettre la plateforme au repos pendant une maintenance plutôt que de désactiver les locataires un par un."
      },
      "discoveryEnabled": {
        "detail": "Balayage qui réconcilie la liste des locataires avec saas-auth, afin que ceux ajoutés ou retirés là-bas apparaissent ici sans saisie manuelle. L'éteindre fige la liste ; les locataires existants continuent de se synchroniser normalement."
      },
      "pruneEnabled": {
        "detail": "Entretien qui supprime les tâches terminées et les événements d'audit plus anciens que les fenêtres de rétention. L'éteindre conserve l'historique indéfiniment et les tables croissent sans limite."
      },
      "orphanSweepEnabled": {
        "detail": "Supprime les fichiers temporaires résiduels du traitement d'assiduité, qui télécharge un classeur généré sur disque et l'efface normalement aussitôt. Ce balayage est le filet de sécurité si le processus est tué pendant le téléchargement. Il ne touche ni aux tâches ni aux données."
      },
      "dispatcherIntervalSeconds": {
        "detail": "Fréquence à laquelle le moteur vérifie quelles tâches sont dues et les met en file. C'est un plancher pour tout le reste : une tâche programmée chaque minute ne démarre qu'au passage du répartiteur. À 900 s (15 min), une fenêtre d'assiduité avance au plus quatre fois par heure ; à 60 s, jusqu'à une fois par minute. L'abaisser coûte peu — la vérification est une seule requête."
      },
      "claimerIntervalSeconds": {
        "detail": "Fréquence à laquelle les workers cherchent du travail en file. Il s'agit d'un sondage de lignes déjà créées : cela règle la latence de prise en charge, pas le volume de travail. Les 5 s par défaut méritent rarement d'être changées."
      },
      "heartbeatIntervalSeconds": {
        "detail": "Fréquence à laquelle une tâche en cours signale qu'elle est vivante, prolongeant son bail. Doit rester nettement inférieure au TTL du bail, sinon une tâche longue et saine — un parcours de genèse, une grande fenêtre d'assiduité — sera récupérée comme si elle avait échoué."
      },
      "reaperIntervalSeconds": {
        "detail": "Fréquence à laquelle le moteur cherche les tâches dont le bail a expiré ou qui ont dépassé la durée maximale, et les remet en file. C'est ce qui récupère le travail après un plantage ou un déploiement ayant redémarré l'application en pleine exécution."
      },
      "terminalCleanupIntervalSeconds": {
        "detail": "Fréquence de suppression des tâches terminées au-delà de la rétention. Pur entretien ; ne touche jamais au travail en cours ou en attente."
      },
      "discoveryIntervalSeconds": {
        "detail": "Fréquence de réconciliation de la liste des locataires avec saas-auth. Toutes les heures suffit largement — un nouveau locataire apparaît en un intervalle."
      },
      "pruneIntervalSeconds": {
        "detail": "Fréquence du nettoyage par rétention. Peu fréquent convient : c'est une suppression en masse, mieux vaut la lancer rarement que constamment."
      },
      "orphanSweepIntervalSeconds": {
        "detail": "Fréquence de recherche des fichiers temporaires résiduels. Seuls ceux plus anciens que l'âge de balayage sont supprimés : peut donc tourner rarement sans risque."
      },
      "terminalRetentionSeconds": {
        "detail": "Durée de conservation des tâches terminées avant purge. C'est votre historique : à 14 jours vous pouvez enquêter sur un échec de la semaine passée, pas du mois passé. L'augmenter coûte de la taille de table, pas de la performance."
      },
      "eventRetentionSeconds": {
        "detail": "Durée de conservation des événements d'audit et d'activité. Plus longue que la rétention des tâches, par conception — les événements consignent ce qui a changé et par qui, ce qui reste utile bien après que la tâche l'ayant produit n'importe plus."
      },
      "orphanSweepAgeSeconds": {
        "detail": "Âge qu'un fichier temporaire doit atteindre avant suppression. Doit dépasser le téléchargement d'assiduité le plus lent réaliste, sinon le balayage risquerait d'effacer un fichier encore utilisé. Les 6 heures par défaut sont volontairement généreuses."
      },
      "defaultFrequencySeconds": {
        "detail": "Intervalle de répétition utilisé par les types de tâches sans planification propre. Les types qui en ont une — synchronisations quotidiennes, balayage de réconciliation, temporisations de rattrapage — l'ignorent entièrement."
      },
      "leaseTtlSeconds": {
        "detail": "Durée pendant laquelle une tâche prélevée est réputée vivante sans battement avant que le récupérateur puisse la reprendre. Réglez-la à plusieurs fois l'intervalle de battement ; trop serrée, des tâches longues et saines sont reprises en cours et refont du travail."
      },
      "maxExecutionTimeSeconds": {
        "detail": "Plafond absolu d'une exécution, indépendamment des battements. Une tâche au-delà est considérée bloquée et arrêtée plutôt que réessayée indéfiniment. Doit dépasser votre exécution légitime la plus lente — une grande fenêtre d'assiduité ou un long parcours de genèse."
      },
      "retryBackoffBaseSeconds": {
        "detail": "Attente initiale avant de réessayer une tâche en échec. Chaque échec suivant attend plus longtemps, jusqu'au plafond ci-dessous, pour qu'une panne passagère ne devienne pas une boucle de reprises serrée contre un système déjà en difficulté."
      },
      "retryBackoffCapSeconds": {
        "detail": "Attente maximale que la reprise peut atteindre. Cela borne le vieillissement des données pendant une panne durable : à 1 heure, un locataire réessaie au moins toutes les heures, quelle que soit la durée de l'indisponibilité."
      },
      "ratePerTenantPeriodSeconds": {
        "detail": "Fenêtre temporelle sur laquelle sont comptés les jetons de requête par locataire. Avec les jetons ci-dessous, cela forme la règle « au plus N requêtes par locataire et par période » — le contrôle principal de la pression exercée sur un studio WStudio donné."
      },
      "rateGlobalPeriodSeconds": {
        "detail": "Fenêtre du plafond de requêtes à l'échelle de la plateforme. Ne s'applique que si les jetons globaux sont supérieurs à zéro. Nécessite un redémarrage."
      },
      "maxAttempts": {
        "detail": "Nombre de reprises d'une tâche en échec avant de la marquer définitivement échouée. À distinguer des sauvetages : les tentatives comptent l'échec de la tâche, les sauvetages comptent la mort du worker."
      },
      "maxRescues": {
        "detail": "Nombre de fois qu'une tâche peut être récupérée après la mort de son worker — plantage ou déploiement — avant d'être jugée toxique et échouée. Compté séparément des tentatives, pour ne pas imputer à une tâche des échecs qu'elle n'a pas causés."
      },
      "batchClaimSize": {
        "detail": "Nombre de tâches en file qu'un worker prélève en un seul aller-retour base de données. Les gros lots réduisent la surcharge quand la file est profonde ; les petits répartissent mieux. Rarement à modifier."
      },
      "perTenantInFlightCap": {
        "detail": "Nombre maximal de tâches pouvant s'exécuter simultanément pour un même locataire. À 1, ses synchronisations ventes, assiduité, produits et utilisateurs s'enchaînent strictement — principale raison pour laquelle le chargement de l'historique paraît lent. Passer à 3 permet au rattrapage d'assiduité d'avancer en parallèle, sans qu'un locataire monopolise tout le pool."
      },
      "maxConcurrent": {
        "detail": "Nombre total de tâches exécutées simultanément, tous locataires confondus. C'est le plafond de la plateforme ; la limite par locataire le répartit équitablement. Avec 5 simultanées et une limite de 3 par locataire, un locataire actif ne peut jamais occuper plus de trois des cinq places. Nécessite un redémarrage."
      },
      "failureAlertThreshold": {
        "detail": "Nombre d'échecs consécutifs de la même tâche pour le même locataire avant qu'une notification soit émise. À 3, les deux premiers échecs sont silencieux. Mettez 1 pour être averti de chaque échec — utile lors de l'intégration de locataires ou du diagnostic d'une nouvelle connexion."
      },
      "failureBreakerMaxFailures": {
        "detail": "Nombre de jours distincts (heure du studio) pendant lesquels une tâche peut échouer pour un locataire — comptés depuis sa dernière exécution réussie ou sa réactivation, et uniquement dans la fenêtre du disjoncteur — avant la désactivation du service de ce locataire. 0 le désactive dès le premier jour d'échec. Distinct du seuil d'alerte d'échec ci-dessus, qui n'émet qu'une notification."
      },
      "failureBreakerWindowHours": {
        "detail": "Seuls les échecs survenus durant ces dernières heures comptent pour le disjoncteur. 0 désactive le disjoncteur : les échecs déclenchent toujours des alertes, mais le service n'est jamais désactivé."
      },
      "ratePerTenantPermits": {
        "detail": "Nombre de requêtes WStudio autorisées par locataire dans chaque période. C'est le bouton de courtoisie — il limite la pression sur un studio donné, indépendamment du nombre de tâches en cours. Baissez-le si le système distant se plaint ; augmentez-le avec prudence."
      },
      "rateGlobalPermits": {
        "detail": "Plafond global, tous locataires confondus. Zéro le désactive, ne laissant que la limite par locataire — la configuration habituelle, les studios étant des systèmes distincts et le trafic d'un locataire ne pesant pas sur celui d'un autre. Nécessite un redémarrage."
      },
      "skipLockedClaim": {
        "detail": "Permet aux workers d'ignorer les lignes déjà verrouillées par un autre plutôt que de les attendre. Gardez-le activé : sinon les workers font la queue sur les mêmes lignes et le débit chute fortement. Ne le désactivez que si la base de données ne gère pas cette fonction."
      },
      "isolation": {
        "detail": "Niveau d'isolation des transactions lors du prélèvement des tâches. `READ_COMMITTED` est le bon choix pour cette file et ne devrait pas changer sans raison précise — des niveaux plus stricts ajoutent de la contention sans bénéfice ici. Nécessite un redémarrage."
      }
    },
    "emphasis": {
      "dispatcherInterval": "C'est un plancher pour tout le reste : une tâche programmée chaque minute ne démarre qu'au passage du répartiteur.",
      "inFlightCap": "À 1, ses synchronisations ventes, assiduité, produits et utilisateurs s'enchaînent strictement — principale raison pour laquelle le chargement de l'historique paraît lent.",
      "failureBreakerMaxFailures": "Jours distincts (heure du studio) avec une exécution échouée, depuis la dernière exécution réussie ou la réactivation, avant la désactivation du service. 0 = désactiver dès le premier jour d'échec.",
      "failureBreakerWindowHours": "Seuls les échecs survenus dans ce nombre d'heures comptent. 0 = disjoncteur désactivé (alertes uniquement)."
    },
    "knob": {
      "dispatcherIntervalSeconds": "Intervalle du dispatcher",
      "claimerIntervalSeconds": "Intervalle du claimer",
      "heartbeatIntervalSeconds": "Intervalle du heartbeat",
      "reaperIntervalSeconds": "Intervalle du reaper",
      "terminalCleanupIntervalSeconds": "Intervalle de nettoyage terminal",
      "discoveryIntervalSeconds": "Intervalle de découverte",
      "pruneIntervalSeconds": "Intervalle d'élagage",
      "orphanSweepIntervalSeconds": "Intervalle de balayage des orphelins",
      "terminalRetentionSeconds": "Rétention terminale",
      "eventRetentionSeconds": "Rétention des événements",
      "orphanSweepAgeSeconds": "Âge de balayage des orphelins",
      "defaultFrequencySeconds": "Fréquence par défaut",
      "leaseTtlSeconds": "TTL du bail",
      "maxExecutionTimeSeconds": "Temps d'exécution maximal",
      "retryBackoffBaseSeconds": "Base de repli des réessais",
      "retryBackoffCapSeconds": "Plafond de repli des réessais",
      "ratePerTenantPeriodSeconds": "Période de limite de débit (par locataire)",
      "rateGlobalPeriodSeconds": "Période de limite de débit (globale)",
      "maxAttempts": "Tentatives maximales",
      "maxRescues": "Sauvetages maximaux",
      "batchClaimSize": "Taille de lot de réclamation",
      "perTenantInFlightCap": "Plafond en cours (par locataire)",
      "maxConcurrent": "Concurrence maximale",
      "failureAlertThreshold": "Seuil d'alerte d'échec",
      "failureBreakerMaxFailures": "Jours d'échec tolérés",
      "failureBreakerWindowHours": "Fenêtre du disjoncteur (heures)",
      "ratePerTenantPermits": "Permis de limite de débit (par locataire)",
      "rateGlobalPermits": "Permis de limite de débit (globaux)",
      "skipLockedClaim": "Ignorer les verrouillés lors de la réclamation",
      "isolation": "Isolation des transactions"
    }
  },
  "jobs": {
    "tableAriaLabel": "Tâches d'ingestion",
    "empty": "Aucune tâche enregistrée.",
    "prevPage": "Page précédente",
    "nextPage": "Page suivante",
    "pageIndicator": "Page {{page}} sur {{total}}",
    "col": {
      "job": "Tâche",
      "status": "Statut",
      "type": "Type",
      "tenant": "Locataire",
      "started": "Démarré",
      "duration": "Durée",
      "records": "Enregistrements",
      "actions": "Actions"
    },
    "status": {
      "queued": "En file",
      "running": "En cours",
      "success": "Succès",
      "failed": "Échoué",
      "skipped": "Ignoré"
    },
    "chip": {
      "statusAriaLabel": "Statut : {{label}}"
    },
    "actions": {
      "cancel": "Annuler",
      "cancelNotSupported": "Annulation pas encore disponible",
      "cancelAriaLabel": "Annuler la tâche {{id}}"
    }
  },
  "ingestionJobs": {
    "title": "Tâches d'Ingestion",
    "filtersAriaLabel": "Filtres de tâche",
    "filterStatus": "Statut",
    "filterType": "Type",
    "filterTenant": "Locataire",
    "allStatuses": "Tous les statuts",
    "allTypes": "Tous les types",
    "allTenants": "Tous les locataires",
    "typeUserSync": "Sync utilisateurs",
    "typeSalesSync": "Sync ventes",
    "typeAttendanceSync": "Sync présences",
    "typeReportSummary": "Résumé sync utilisateurs",
    "totalCount": "{{total}} tâches",
    "tableAriaLabel": "Tâches d'ingestion inter-locataires",
    "loadError": "Impossible de charger les tâches d'ingestion."
  },
  "tenant": {
    "tab": {
      "overview": "Aperçu",
      "members": "Personnel",
      "invitations": "Invitations",
      "ingestion": "Ingestion",
      "history": "Historique de synchronisation",
      "wstudio": "WStudio Config",
      "contacts": "Correspondance des contacts",
      "advanced": "Avancé",
      "settings": "Paramètres"
    }
  },
  "problems": {
    "jobFailures": "{{job}} — {{code}}, {{count}}× en 24 h, il y a {{ago}}",
    "ghlWriteFailures": "{{count}} contacts n’ont pas pu être écrits dans GoHighLevel lors de la dernière exécution.",
    "noData": "{{job}} — aucun enregistrement lors de la dernière exécution ; à vérifier.",
    "verification": "{{job}} — la vérification échoue ; relancez le test à blanc",
    "generic": "{{job}} — nécessite une action"
  },
  "runNow": {
    "button": "Exécuter maintenant",
    "enqueued": "{{service}} a été mis en file d'attente. Il apparaîtra dans la File d'attente dans quelques secondes.",
    "alreadyRunning": "{{service}} est déjà en cours d'exécution.",
    "blockedTitle": "{{service}} ne peut pas s'exécuter :",
    "error": "Impossible de démarrer {{service}}.",
    "queueLink": "Ouvrir la File d'attente",
    "blocked": {
      "GLOBAL_DISABLED": "L'ingestion est désactivée globalement.",
      "TENANT_DISABLED": "Ce locataire est désactivé.",
      "SERVICE_DISABLED": "Ce service est désactivé.",
      "NOT_VERIFIED": "Exécutez d'abord les tests à blanc.",
      "NOT_SYNC_READY": "En attente de la fin du chargement de l'historique.",
      "NOT_CONFIGURED": "Les identifiants WStudio ne sont pas configurés pour ce locataire.",
      "unknown": "Ce service ne peut pas s'exécuter pour le moment."
    }
  },
  "tenantDetail": {
    "loadError": "Impossible de charger le locataire. Veuillez réessayer.",
    "notFound": "Locataire introuvable",
    "notFoundBody": "Le locataire '{{slug}}' est introuvable.",
    "backToRoster": "Retour aux locataires",
    "opsLoadError": "Impossible de charger la configuration opérationnelle.",
    "tabs": {
      "ariaLabel": "Sections de détail du locataire"
    },
    "overview": {
      "disabledTitle": "Désactivé",
      "disabledGlobal": "L'ingestion est désactivée pour toute la plateforme",
      "disabledTenant": "Ce locataire est désactivé",
      "disabledHint": "Modifiez-les dans l'onglet Ingestion.",
      "problemsTitle": "Problèmes",
      "problemsNone": "Aucun problème — les échecs et les vérifications obsolètes apparaissent ici.",
      "problemStale": "{{job}} — la vérification est obsolète, relancez le test à blanc",
      "problemFailed": "{{job}} — la vérification a échoué"
    },
    "settings": {
      "title": "Paramètres WStudio du tenant",
      "formAriaLabel": "Formulaire des paramètres WStudio du tenant",
      "loadError": "Impossible de charger les paramètres WStudio.",
      "save": "Enregistrer les paramètres WStudio",
      "saving": "Enregistrement…",
      "saveSuccess": "Paramètres WStudio enregistrés.",
      "saveSuccessReverify": "La configuration a changé — relancez les quatre tests à blanc pour revérifier ce locataire.",
      "saveError": "Impossible d’enregistrer les paramètres WStudio.",
      "domain": { "label": "Domaine", "help": "URL de base WStudio requise pour le tenant." },
      "token": {
        "label": "Jeton API WStudio",
        "set": "Défini · {{suffix}}",
        "notSet": "Non défini",
        "replace": "Remplacer",
        "replacement": "Nouveau jeton",
        "help": "Écriture seule. Un champ vide conserve le jeton enregistré."
      },
      "studioId": { "label": "ID du studio", "help": "Valeur de l’en-tête Studioid de WStudio." },
      "reportUserId": {
        "label": "ID utilisateur du rapport",
        "help": "ID utilisé pour générer les rapports de présence."
      },
      "contacts": {
        "title": "Mappages des champs de contact",
        "help": "Associez les clés contact.* aux ID de champs GHL.",
        "key": "Clé de contact",
        "value": "ID de champ GHL",
        "add": "Ajouter un mappage",
        "remove": "Supprimer",
        "catalogTitle": "Correspondances standard",
        "catalogHelp": "Gérées globalement et appliquées à chaque locataire. L'ID de champ GoHighLevel est résolu automatiquement.",
        "addedTitle": "Correspondances supplémentaires",
        "addedHelp": "Choisissez un attribut utilisateur WStudio. L'ID de champ GoHighLevel est détecté à l'enregistrement.",
        "col": {
          "key": "Clé de contact",
          "attribute": "Attribut WStudio",
          "fieldId": "ID de champ GoHighLevel",
          "status": "Statut"
        },
        "attributeLabel": "Attribut utilisateur WStudio",
        "fieldKeyLabel": "Clé de champ GoHighLevel",
        "status": {
          "resolved": "Résolu",
          "legacy": "Résolu par ID",
          "notFound": "Introuvable dans GoHighLevel",
          "unknownAttribute": "Attribut inconnu",
          "retired": "Retiré",
          "retiredHelp": "Les correspondances vers les champs principaux ne sont plus prises en charge. Cette correspondance est ignorée — supprimez-la."
        },
        "unresolvedWarning": "Une ou plusieurs correspondances requises n'ont pas pu être résolues. Créez le champ personnalisé correspondant dans GoHighLevel, puis relancez les tests à blanc.",
        "attributesUnavailable": "La liste des attributs WStudio est indisponible ; aucune nouvelle correspondance ne peut être ajoutée pour le moment."
      },
      "advanced": {
        "title": "Avancé — remplacer la config globale",
        "override": "Remplacer",
        "overriding": "Remplacement actif",
        "default": "Par défaut",
        "revert": "Revenir à la valeur par défaut",
        "derived": "Valeur dérivée",
        "defaultValue": "par défaut : {{value}}",
        "fullUrl": "URL complète de remplacement",
        "urlHelp": "Une URL de remplacement remplace entièrement le domaine et le chemin global."
      },
      "validation": {
        "domain": "Le domaine est requis.",
        "contact": "Saisissez une clé contact.<champ> et un ID pour chaque mappage.",
        "duplicateContact": "Les clés de contact doivent être uniques.",
        "attributeRequired": "Choisissez un attribut utilisateur WStudio pour chaque correspondance.",
        "fullUrl": "Saisissez une URL http(s) complète.",
        "nonNegativeInt": "Saisissez un nombre entier supérieur ou égal à 0.",
        "nonNegativeNumber": "Saisissez un montant supérieur ou égal à 0.",
        "valueThresholdOrder": "Le seuil de valeur moyenne doit être inférieur ou égal au seuil de valeur élevée.",
        "tenureOrder": "Le seuil d'ancienneté établie doit être inférieur ou égal au seuil d'ancienneté fidèle."
      },
      "membership": {
        "title": "Adhésion et classification",
        "help": "Ces paramètres sont lus ensemble pour classer les membres à des fins marketing.",
        "valueHelp": "Les deux seuils doivent être définis pour que la classification par valeur s'exécute. Les laisser vides est un choix valide — aucune classification par valeur n'est produite.",
        "valuePartial": "Un seul seuil est défini, la classification par valeur reste donc désactivée."
      },
      "fields": {
        "WStudio_user_listWithFilters": "URL de liste utilisateurs",
        "WStudio_user_listWithFilters_max": "Maximum utilisateurs",
        "WStudio_user_listWithFilters_offset": "Décalage utilisateurs",
        "WStudio_user_listWithFilters_filter": "Filtre utilisateurs",
        "WStudio_sales_listSales": "URL des ventes du tenant",
        "WStudio_sales_listForUser": "URL des ventes par utilisateur",
        "WStudio_sales_listForUser_max": "Maximum des ventes par utilisateur",
        "WStudio_sales_listForUser_offset": "Décalage des ventes par utilisateur",
        "WStudio_sales_listForUser_forceUpdate": "Forcer la mise à jour",
        "WStudio_report_checkin": "URL du rapport de présence",
        "WStudio_product_listByType": "URL du catalogue de produits",
        "WStudio_product_listByType_max": "Maximum du catalogue de produits",
        "WStudio_product_listByType_offset": "Décalage du catalogue de produits",
        "WStudio_product_types": "Types de produits à synchroniser",
        "WStudio_membership_gracePeriodDays": "Période de grâce (jours)",
        "WStudio_membership_shortTermThresholdDays": "Seuil court terme (jours)",
        "WStudio_membership_renewalDueSoonDays": "Renouvellement imminent (jours)",
        "WStudio_membership_tenureEstablishedDays": "Ancienneté établie (jours)",
        "WStudio_membership_tenureLoyalDays": "Ancienneté fidèle (jours)",
        "WStudio_membership_valueMidThreshold": "Seuil de valeur moyenne",
        "WStudio_membership_valueHighThreshold": "Seuil de valeur élevée",
        "WStudio_genesis_syncReadyCoverageDays": "Couverture de présence requise avant synchronisation (jours)"
      }
    },
    "verification": {
      "allVerified": "WStudio vérifié",
      "notVerified": "WStudio non configuré / non vérifié",
      "prompt": "Lancez les quatre tests à blanc pour vérifier ce locataire.",
      "verified": "Vérifié",
      "failed": "Échec",
      "notRun": "Non exécuté",
      "stale": "Obsolète — relance requise"
    },
    "header": {
      "dispatchState": "État de déclenchement",
      "dispatchRunning": "Les synchronisations sont en cours",
      "dispatchUnknown": "État global inconnu",
      "blockedGlobal": "Bloqué — global désactivé",
      "blockedTenant": "Bloqué — locataire désactivé",
      "blockedServices": "Bloqué — aucun service activé",
      "lastSync": "Dernière sync",
      "statusLabel": "Statut locataire : {{status}}",
      "leftRosterChip": "Quitté le registre",
      "leftRosterAriaLabel": "Ce locataire a quitté le registre saas-auth",
      "leftRosterBody": "Ce locataire a quitté le registre saas-auth. Il a été signalé mais pas supprimé — les données existantes sont préservées."
    },
    "actions": {
      "title": "Actions locataire",
      "tenantEnabled": "Locataire activé",
      "enabledLabel": "Locataire activé",
      "disabledLabel": "Locataire désactivé",
      "tenantEnabledHelper": "Quand désactivé, ce locataire est entièrement ignoré — aucune sync, aucun rapport.",
      "enableSuccess": "Locataire activé.",
      "disableSuccess": "Locataire désactivé.",
      "enableError": "Impossible de mettre à jour le statut du locataire. Veuillez réessayer.",
      "confirmEnableTitle": "Activer le locataire ?",
      "confirmEnableBody": "Cela permettra aux synchronisations de s'exécuter pour ce locataire quand les interrupteurs global et de service sont aussi activés.",
      "confirmDisableTitle": "Désactiver le locataire ?",
      "confirmDisableBody": "Cela empêchera toutes les synchronisations et rapports pour ce locataire.",
      "statusActionsTitle": "Statut locataire",
      "markActive": "Marquer actif",
      "suspendTenant": "Suspendre le locataire",
      "statusWriteUnavailable": "La gestion du statut n'est pas encore disponible dans cette console. Utilisez saas-admin pour modifier le statut.",
      "statusWriteHint": "Le statut est géré via saas-admin."
    },
    "confirm": {
      "confirmButton": "Confirmer",
      "cancelButton": "Annuler"
    },
    "gate": {
      "title": "Interrupteurs d'activation",
      "gateRule": "Règle de déclenchement :",
      "explainer": "Une tâche s'exécute uniquement quand global, locataire et service sont TOUS activés.",
      "globalLevel": "Global",
      "globalReadOnly": "Lecture seule ici.",
      "globalLink": "Gérer dans Paramètres Globaux",
      "tenantLevel": "Locataire",
      "tenantHint": "Géré dans Actions locataire ci-dessus.",
      "serviceLevel": "Services",
      "gateOn": "Activé",
      "gateOff": "Désactivé",
      "gateUnknown": "Inconnu"
    },
    "services": {
      "enableSuccess": "{{service}} activé.",
      "disableSuccess": "{{service}} désactivé.",
      "enableError": "Impossible de mettre à jour {{service}}."
    },
    "config": {
      "title": "Configuration",
      "formAriaLabel": "Formulaire de configuration locataire",
      "saveButton": "Enregistrer la configuration",
      "saving": "Enregistrement…",
      "resetButton": "Réinitialiser",
      "unsavedChanges": "Modifications non enregistrées",
      "saveSuccess": "Configuration enregistrée.",
      "saveError": "Impossible d'enregistrer la configuration. Veuillez réessayer.",
      "validationError": "Validation échouée. Vérifiez vos saisies et réessayez.",
      "fieldRequired": "Ce champ est obligatoire.",
      "freqMin1": "La fréquence doit être un entier ≥ 1.",
      "invalidTime": "Doit être au format HH:mm (ex. 00:30).",
      "invalidSendTimes": "Chaque heure doit être au format HH:mm, séparées par des virgules.",
      "invalidDate": "Doit être une date valide (AAAA-MM-JJ).",
      "cooldownMin1": "Le délai doit être un entier ≥ 1.",
      "userSyncFrequency": "Fréquence de sync utilisateurs (heures)",
      "userSyncFrequencyHelper": "À quelle fréquence la sync WStudio→GHL s'exécute. Minimum 1.",
      "dailySyncTime": "Heure de sync quotidienne (HH:mm)",
      "dailySyncTimeHelper": "Quand l'extraction quotidienne du jour précédent s'exécute.",
      "userSyncSendTimes": "Heures d'envoi du résumé",
      "userSyncSendTimesPlaceholder": "ex. 09:00,17:00",
      "userSyncSendTimesHelper": "Heures HH:mm séparées par des virgules pour le courriel de résumé. Vide = aucun rapport planifié.",
      "backfillStartDate": "Date de début du remplissage",
      "backfillStartDateHelper": "Date de genèse pour le remplissage ventes/présences (AAAA-MM-JJ).",
      "backfillCooldown": "Délai de remplissage (minutes)",
      "backfillCooldownHelper": "Repos entre les blocs hebdomadaires de remplissage en minutes."
    },
    "dryRun": {
      "title": "Tests à blanc",
      "subtitle": "Validez avant d'activer — aucune donnée n'est écrite.",
      "salesTitle": "Test à blanc ventes",
      "attendanceTitle": "Test à blanc présences",
      "userTitle": "Test à blanc utilisateurs",
      "ghlFieldsTitle": "Vérification des champs GHL",
      "from": "Du",
      "to": "Au",
      "run": "Lancer le test",
      "running": "En cours…",
      "runError": "La requête de test à blanc a échoué. Veuillez réessayer.",
      "success": "Succès",
      "failure": "Échoué",
      "notConfigured": "Non configuré",
      "warnings": "Avertissements",
      "sampleData": "Données d'exemple",
      "sampleRows": "{{n}} lignes",
      "errorLabel": "Erreur :",
      "unknownError": "Erreur inconnue",
      "writeNothing": "Test à blanc uniquement — aucune donnée n'est écrite, aucune marque n'est déplacée.",
      "table": {
        "title": "Enregistrements d'exemple",
        "count": "{{n}} sur {{total}} récupérés",
        "empty": "Aucun enregistrement dans cette fenêtre.",
        "mapped": "mappé"
      },
      "match": {
        "create": "Créer",
        "update": "Mettre à jour",
        "noChange": "Inchangé"
      },
      "counts": {
        "user": "{{n}} utilisateurs récupérés",
        "sales": "{{n}} enregistrements récupérés (une page)",
        "attendance": "{{n}} lignes analysées",
        "generic": "{{n}} enregistrements récupérés",
        "salesHelp": "Une page selon le maximum configuré — ce n'est ni le total des ventes du locataire, ni nécessairement les ventes les plus récentes."
      },
      "plan": {
        "title": "Plan de synchronisation",
        "population": "{{wstudioUsers}} utilisateurs WStudio · {{ghlContacts}} contacts GoHighLevel",
        "create": "{{n}} seraient créés",
        "update": "{{n}} seraient mis à jour",
        "noChange": "{{n}} déjà à jour",
        "unmatched": "{{n}} contacts sans correspondance WStudio",
        "unmatchedHelp": "Ils ne sont pas modifiés — la synchronisation ne désactive ni ne supprime jamais de contacts.",
        "lastPurchaseFootnote": "Les changements de dernier achat ne sont pas vérifiés ; le nombre de mises à jour est donc un minimum.",
        "cappedWarning": "L'extraction des utilisateurs WStudio a été plafonnée — ces chiffres ne couvrent qu'une partie de la population.",
        "allCreateWarning": "GoHighLevel contient {{ghlContacts}} contacts, pourtant les {{wstudioUsers}} utilisateurs WStudio seraient créés au lieu d'être associés. La correspondance contact.wstudio_id pointe vers le mauvais champ GoHighLevel et une synchronisation réelle dupliquerait tous les contacts. Vérifiez la correspondance avant d'activer la synchronisation."
      },
      "requestUrl": {
        "label": "Requête WStudio"
      },
      "attendance": {
        "title": "Analyse du rapport",
        "rowsInSheet": "{{n}} lignes dans le rapport",
        "parsed": "{{n}} analysées",
        "openGym": "{{n}} lignes de salle libre ignorées",
        "incomplete": "{{n}} lignes incomplètes ignorées",
        "emptyReport": "Le rapport a été généré correctement mais ne contenait aucune ligne pour cette fenêtre.",
        "incompleteWarning": "{{n}} lignes sur {{total}} sont arrivées sans date, heure ni membre. Cela signifie généralement que la disposition des colonnes du rapport de présence a changé — vérifiez le rapport avant de vous fier à cette synchronisation."
      },
      "ghlFields": {
        "checked": "{{n}} correspondances vérifiées",
        "present": "{{n}} présents",
        "missing": "{{n}} absents de GoHighLevel",
        "unresolved": "{{n}} jamais résolus",
        "matchKeyBroken": "contact.wstudio_id — le champ qui associe les utilisateurs WStudio aux contacts GoHighLevel — est {{outcome}}. Tant qu'il n'est pas corrigé, une synchronisation réelle ne trouverait aucune correspondance et créerait un contact en double pour chaque utilisateur à chaque exécution.",
        "repairHelp": "Les champs manquants doivent être créés ou renommés dans GoHighLevel, puis relancez ce test. La console ne peut pas les créer."
      }
    },
    "syncWindow": {
      "title": "État de la fenêtre de sync",
      "syncWindow": "fenêtre de sync",
      "inBackfill": "En remplissage",
      "steadyState": "État stable",
      "progress": "Progression du remplissage",
      "cursor": "Curseur",
      "lastWindow": "Dernière fenêtre",
      "never": "—",
      "loadError": "Impossible de charger l'état de la fenêtre de sync."
    },
    "jobs": {
      "title": "Tâches d'ingestion · ce locataire",
      "tableAriaLabel": "Tâches d'ingestion pour ce locataire",
      "loadError": "Impossible de charger l'historique des tâches."
    },
    "identity": {
      "loadError": "Impossible de charger l'identité du locataire.",
      "opsNotProvisioned": "La configuration opérationnelle de ce locataire n'est pas encore disponible — wsr-api ne l'a pas encore répliqué. Elle apparaîtra lors de sa prochaine synchronisation.",
      "status": {
        "ACTIVE": "Actif",
        "INACTIVE": "Inactif",
        "SUSPENDED": "Suspendu"
      }
    },
    "members": {
      "title": "Personnel",
      "help": "Qui peut se connecter au wsr-admin de ce locataire.",
      "tableAriaLabel": "Personnel du locataire",
      "col": {
        "email": "E-mail",
        "name": "Nom",
        "role": "Rôle",
        "status": "Statut",
        "actions": "Actions"
      },
      "role": {
        "OWNER": "Propriétaire",
        "SUPER_ADMIN": "Super Admin",
        "ADMIN": "Admin",
        "STAFF": "Personnel",
        "USER": "Utilisateur",
        "GUEST": "Invité"
      },
      "status": {
        "ACTIVE": "Actif",
        "INVITED": "Invité",
        "DISABLED": "Désactivé"
      },
      "loadError": "Impossible de charger le personnel.",
      "empty": "Aucun personnel pour l'instant.",
      "changeRoleLabel": "Rôle pour {{email}}",
      "changeRoleError": "Impossible de changer le rôle. Veuillez réessayer.",
      "disableLabel": "Activé",
      "toggleStatusError": "Impossible de mettre à jour le statut du personnel. Veuillez réessayer.",
      "removeButton": "Retirer",
      "removeConfirmTitle": "Retirer le personnel ?",
      "removeConfirmBody": "Cela retire {{email}} du personnel wsr-admin de ce locataire. Son compte n'est pas supprimé.",
      "removeError": "Impossible de retirer le personnel. Veuillez réessayer.",
      "lastOwnerProtected": "Cela supprimerait le dernier propriétaire du locataire.",
      "roleChangeCrossesTables": "Ce changement de rôle n'est pas autorisé pour ce membre du personnel.",
      "addTitle": "Ajouter du personnel",
      "addEmailLabel": "E-mail",
      "addEmailRequired": "L'e-mail est obligatoire.",
      "addRoleLabel": "Rôle",
      "addButton": "Ajouter",
      "addSuccessMember": "Personnel ajouté.",
      "addSuccessInvitation": "Invitation envoyée.",
      "addErrorAlreadyActive": "Cette personne fait déjà partie du personnel actif.",
      "addErrorAlreadyPending": "Une invitation est déjà en attente pour cet e-mail.",
      "addError": "Impossible d'ajouter le personnel. Veuillez réessayer."
    },
    "invitations": {
      "title": "Invitations",
      "tableAriaLabel": "Invitations du locataire",
      "col": {
        "email": "E-mail",
        "role": "Rôle",
        "status": "Statut",
        "created": "Créée",
        "expires": "Expire",
        "actions": "Actions"
      },
      "statusAll": "Tout afficher",
      "status": {
        "PENDING": "En attente",
        "ACCEPTED": "Acceptée",
        "REVOKED": "Révoquée",
        "EXPIRED": "Expirée"
      },
      "loadError": "Impossible de charger les invitations.",
      "empty": "Aucune invitation en attente.",
      "emptyAll": "Aucune invitation.",
      "resendButton": "Renvoyer",
      "resendError": "Impossible de renvoyer l'invitation. Veuillez réessayer.",
      "revokeButton": "Révoquer",
      "revokeConfirmTitle": "Révoquer l'invitation ?",
      "revokeConfirmBody": "Cela révoque l'invitation en attente à {{email}}. Elle ne pourra plus l'accepter.",
      "revokeError": "Impossible de révoquer l'invitation. Veuillez réessayer.",
      "alreadyAccepted": "Cette invitation a déjà été acceptée. La liste a été actualisée.",
      "notFound": "Cette invitation est introuvable. La liste a été actualisée."
    }
  },
  "tenantQueue": {
    "title": "File d'attente",
    "empty": "Rien en cours ni planifié."
  },
  "warehouse": {
    "title": "Entrepôt",
    "members": "Membres WStudio",
    "sales": "Ventes",
    "attendance": "Présences",
    "products": "Produits",
    "syncedAgo": "synchronisé il y a {{duration}}",
    "fullHistory": "historique complet",
    "backTo": "jusqu'à {{date}}"
  },
  "activity": {
    "title": "Activité",
    "ranAgo": "il y a {{duration}}",
    "col": {
      "job": "Tâche",
      "kind": "Type",
      "records": "Enregistrements",
      "ran": "Exécuté",
      "next": "Prochain"
    },
    "caughtUp": "À jour",
    "counters": {
      "fetched": "{{n}} récupérés",
      "landed": "{{n}} chargés",
      "updated": "{{n}} mis à jour",
      "unchanged": "{{n}} inchangés",
      "failed": "{{n}} échoués",
      "ghlUpdates": "{{n}} mises à jour GHL",
      "ghlInserts": "{{n}} insertions GHL",
      "ghlFailures": "{{n}} échecs GHL",
      "ghlContactsRetrieved": "{{n}} contacts GHL récupérés",
      "labelRows": "{{n}} lignes d'étiquettes",
      "categoryRows": "{{n}} lignes de catégorie",
      "detailLines": "{{n}} lignes de détail",
      "duplicatesCollapsed": "{{n}} doublons regroupés",
      "rowsInSheet": "{{n}} lignes dans la feuille"
    },
    "kind": {
      "GENESIS": "genèse",
      "BACKFILL": "historique",
      "LEADING_EDGE": "flux courant",
      "INCREMENTAL": "incrémental"
    },
    "next": {
      "in": "dans {{duration}}",
      "off": "désactivé"
    }
  },
  "syncHistory": {
    "title": "Historique de synchronisation",
    "emptyJobs": "Aucune exécution de synchronisation au cours des 14 derniers jours.",
    "emptyJournalUserSync": "Aucune modification par utilisateur lors de cette exécution.",
    "emptyJournalOtherType": "Ce type de tâche n'a pas de journal par ligne. Le résultat et les compteurs figurent dans l'en-tête de l'exécution.",
    "emptyJournalUnknown": "Aucun journal par ligne pour cette exécution.",
    "jobNotFound": "Cette exécution n'est plus conservée.",
    "backToList": "Retour à la liste",
    "loadError": "Impossible de charger l'historique de synchronisation.",
    "journalTitle": "Journal",
    "jobTitle": "Tâche {{id}}",
    "filters": {
      "statusAria": "Filtrer par statut",
      "allStatuses": "Tous les statuts",
      "typeLabel": "Type de tâche",
      "allTypes": "Tous les types",
      "severityLabel": "Gravité",
      "allSeverities": "Toutes les gravités"
    },
    "col": {
      "id": "Id",
      "job": "Tâche",
      "status": "Statut",
      "kind": "Type",
      "finished": "Terminé",
      "records": "Enregistrements",
      "when": "Quand",
      "severity": "Grav.",
      "action": "Action",
      "entity": "Entité",
      "summary": "Résumé"
    },
    "action": {
      "CREATED": "CRÉÉ",
      "UPDATED": "MIS À JOUR",
      "TAGGED": "ÉTIQUETÉ",
      "FAILED": "ÉCHOUÉ"
    },
    "entity": {
      "USER": "Utilisateur",
      "GHL_CONTACT": "Contact GoHighLevel"
    },
    "facts": {
      "show": "Afficher les détails",
      "hide": "Masquer les détails"
    },
    "prevPage": "Page précédente",
    "nextPage": "Page suivante",
    "pageIndicator": "Page {{page}} sur {{total}}"
  },
  "genesis": {
    "complete": "Terminé",
    "loading": "Chargement de l'historique",
    "notStarted": "Non démarré",
    "coveredFrom": "jusqu'au {{date}}",
    "coverageDays": "{{n}} jours couverts",
    "windowsRemaining": "{{n}} fenêtres restantes"
  },
  "readiness": {
    "notConfigured": "WStudio n'est pas encore configuré pour ce locataire.",
    "notVerified": "Lancez les tests à blanc WStudio pour vérifier cette configuration. Si la configuration a changé récemment, relancez-les.",
    "readyToStart": "Vérifié et prêt. Activez ce locataire pour commencer à charger son historique.",
    "blockedGlobal": "L'ingestion est désactivée pour toute la plateforme. Activez-la dans Locataires → Activer l'ingestion globale.",
    "blockedTenant": "Vérifié et prêt. Activez ce locataire pour commencer à charger son historique.",
    "blockedServices": "Vérifié et prêt, mais ces services sont désactivés : {{services}}.",
    "genesisSales": "Chargement de l'historique des ventes. Cela se résout tout seul — aucune action requise.",
    "genesisAttendance": "Chargement de l'historique de présence. Cela se résout tout seul — aucune action requise.",
    "syncing": "Synchronisation avec GoHighLevel. L'historique de présence plus ancien est encore en cours de chargement, les signaux d'engagement ne sont donc pas encore disponibles — c'est normal."
  },
  "phase": {
    "notConfigured": "Non configuré",
    "notVerified": "Non vérifié",
    "readyToStart": "Prêt à démarrer",
    "genesisSales": "Chargement des ventes",
    "genesisAttendance": "Chargement des présences",
    "syncing": "Synchronisation",
    "complete": "Terminé"
  },
  "emailIdentity": {
    "title": "Identité e-mail",
    "fromName": "Nom de l'expéditeur",
    "fromAddress": "Adresse de l'expéditeur",
    "supportEmail": "Adresse de support",
    "managedElsewhere": "Configuré en dehors de cette console."
  },
  "reset": {
    "title": "Réinitialiser les données WStudio",
    "description": "Supprime définitivement tout ce que ce locataire a téléchargé depuis WStudio. Irréversible.",
    "button": "Réinitialiser",
    "blocked": {
      "tenantEnabled": "Désactivez ce locataire avant de le réinitialiser.",
      "jobsInFlight": "Attendez la fin des tâches en cours, puis réessayez."
    },
    "willDelete": "Ceci supprimera définitivement :",
    "showAllTables": "Afficher toutes les tables",
    "kept": "Conservés : le locataire, sa planification et ses interrupteurs, les destinataires des rapports et l'historique d'audit.",
    "ghlNote": "GoHighLevel n'est pas affecté. Les contacts, champs personnalisés et tags de ces membres restent dans GoHighLevel et doivent y être supprimés.",
    "alsoDeleteConfig": "Effacer aussi les paramètres de connexion WStudio",
    "alsoDeleteConfigHelp": "Vous devrez ressaisir le domaine, le jeton et le Studio ID avant que ce locataire puisse se synchroniser.",
    "confirmLabel": "Saisissez {{slug}} pour confirmer",
    "confirmButton": "Supprimer définitivement",
    "successTitle": "Réinitialisation terminée",
    "successNextSteps": "Ce locataire n'est plus vérifié et rien ne s'exécutera. Lancez les tests à blanc, puis activez-le pour recharger l'historique.",
    "confirmMismatch": "Le nom du locataire ne correspond pas.",
    "nothingDeleted": "Rien n'a été supprimé."
  },
  "bootstrap": {
    "error": "Impossible de charger la configuration de l'application.",
    "errorNotRegistered": "Cet hôte n'est pas enregistré. Contactez votre administrateur.",
    "retry": "Réessayer"
  },
  "errors": {
    "generic": "Quelque chose s'est mal passé. Veuillez réessayer.",
    "network": "Erreur réseau. Vérifiez votre connexion et réessayez.",
    "codes": {
      "SESSION_EXPIRED": "Votre session a expiré. Reconnectez-vous.",
      "NETWORK_ERROR": "Erreur réseau. Vérifiez votre connexion et réessayez.",
      "UNKNOWN": "Quelque chose s'est mal passé."
    }
  }
}
